import { Button } from "antd";
import { useState } from "react";
import ConfirmModal from "src/components/Modals/ConfirmModal";
import { Tag } from "src/models/TagModel";
import { useDeleteTagMutation } from "src/store/apis/Tags";

interface Props {
  value?: Tag;
}

export default function DeleteModal({ value }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const [deleteTag, { isLoading, isSuccess }] = useDeleteTagMutation();

  function handleOk() {
    if (!value) return;

    try {
      deleteTag({ data: { id: value?.id } }).then(() => {
        setIsOpen(false);
      });
    } catch (error) {
      // TODO: implement toaster
      console.error(error);
    }
  }

  return (
    <>
      <Button color="danger" onClick={() => setIsOpen(true)}>
        Delete
      </Button>
      <ConfirmModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleOk}
        isLoadingCancel={isLoading}
        isSuccessCancel={isSuccess}
      >
        <h3>
          Are you sure you want to delete{" "}
          <span className="font-bold">{value?.name}</span>?
        </h3>
      </ConfirmModal>
    </>
  );
}
